import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/vee'
import './plugins/vuetoastification'
import * as Sentry from '@sentry/vue'
import configs from '@/configs'
import { errorFunction } from '@/utils'
import setApiRoutes from './helpers/setApiRoutes'

Sentry.init({
    attachStacktrace: true,
    dsn: 'https://7e59b1fb0755b52d7114fa76ba565769@o4510029561724928.ingest.us.sentry.io/4510047820447744',
    enabled: configs.ENABLE_TRACING,
    enableLogs: true,
    environment: `${configs.module.toLowerCase()}_${configs.env}`,
    integrations: [Sentry.browserTracingIntegration({ router })],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    Vue,
})

Vue.prototype.$fnError = errorFunction

import { setupMoment } from './plugins/moment'

setupMoment(vuetify.framework.lang.current)

Vue.config.productionTip = false

const { system, env } = configs

setApiRoutes(Vue, system, env)
store.dispatch('notification/connect')

Vue.prototype.$vuetify = vuetify

new Vue({
    render: (h) => h(App),
    router,
    store,
    vuetify,
}).$mount('#app')
